module.exports = __webpack_public_path__ + "static/atlaskit-table-truncate-40f056fbf59f4bdfbf7c9ae865df6efd.png";